import React from 'react';
import PropTypes from 'prop-types';
import EventRowProto from './EventRowProto';

class EventRow extends EventRowProto {

  static displayName = 'EventRow';

  static propTypes = {
    segments: PropTypes.array,
  };

  render() {
    const { segments } = this.props;

    let lastEnd = 1;

    return (
      <div className="rbc-row">
        {
        segments.reduce((row, { event, left, right, span }, li) => {
          const key = `_lvl_${li}`;
          const gap = left - lastEnd;

          const content = this.renderEvent(event);

          if (gap) {
            row.push(this.renderSpan(gap, `${key}_gap`));
          }

          row.push(
            this.renderSpan(span, key, content)
          );

          lastEnd = (right + 1);

          return row;
        }, [])
      }
      </div>
    );
  }
}

export default EventRow;
